import { render } from "./TheScheduleServiceForm.vue?vue&type=template&id=756b0cd8"
import script from "./TheScheduleServiceForm.vue?vue&type=script&lang=js"
export * from "./TheScheduleServiceForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__